/**
 * A shipment is open, then in production while it is being made (when it is of a service center that produces),
 * then ready to ship once every order on it has been produced, in transit once it has left, and closed once it is
 * back.  It can be cancelled until it is closed.  The numbers are the ones the API uses.
 */
export enum ShipmentStatus {
    Cancelled = -1,
    Open = 0,
    InProduction = 1,
    ReadyToShip = 2,
    InTransit = 3,
    Closed = 4
}

export const ShipmentStatusMetadata = {
    '-1': {
        display: 'Cancelled',
        class: 'cancelled',
        value: -1
    },
    '0': {
        display: 'Open',
        class: 'open',
        value: 0
    },
    '1': {
        display: 'In Production',
        class: 'inproduction',
        value: 1
    },
    '2': {
        display: 'Ready To Ship',
        class: 'readytoship',
        value: 2
    },
    '3': {
        display: 'In-Transit',
        class: 'intransit',
        value: 3
    },
    '4': {
        display: 'Closed',
        class: 'closed',
        value: 4
    }
};
